var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgService(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.4844 51.469L21.9062 3.95338C22.1562 2.32838 24.3281 1.95338 25.1094 3.40651L33.0781 18.3128L14.4844 51.469ZM67.4219 62.5159L60.125 19.2659C59.9062 17.9065 58.2031 17.344 57.2344 18.3284L12.4219 62.5159L37.3281 76.8753C38.8594 77.7346 40.7812 77.7346 42.3125 76.8753L67.4219 62.5159ZM47.1719 24.844L41.4688 13.9846C40.8281 12.7503 39.0781 12.7503 38.4375 13.9846L13.3281 58.719L47.1719 24.844Z",
    fill: "#140E0B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgService);
export default __webpack_public_path__ + "static/media/service.48a8fc69a6e98571ac6a4b46a2174783.svg";
export { ForwardRef as ReactComponent };